export default __webpack_public_path__ + "static/media/prog6.872b0ff7.jpg";